// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3748) return "static/chunks/3748-f3182070e59e5a89.js";
	if (chunkId === 5463) return "static/chunks/5463-22058a1162a9f793.js";
	if (chunkId === 165) return "static/chunks/165-4f7874822f6cfe99.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"680":"21e5dfeacc86fce6","1465":"afc3cf9dc98ddc6b","2498":"ae6c432ce3818a22","2625":"72b1c9bd8543fae2","5119":"3ecc1c85760b6d71","5343":"58cdde965f1584b2","8933":"db0639f090235a1d"}[chunkId] + ".js";
};